export default __webpack_public_path__ + "static/media/earth-rotating-2.dc707982.mp4";